import { type FC, useEffect } from 'react'

import { useUnit } from 'effector-react'

import { Dialog } from '@/components/ui/dialog'
import { Skeleton } from '@/components/ui/skeleton'
import type { DialogProps } from '@/dialogs/types'
import { $gif, loadGif } from '@/models/chattingUI/giphy.ts'

interface Props extends DialogProps {
  giphyId: string
}

export const LoadGifDialog: FC<Props> = ({ giphyId, isOpen, onClose }) => {
  const data = useUnit($gif)

  useEffect(() => {
    loadGif(giphyId)
  }, [giphyId])

  return (
    <Dialog
      bigDialog
      childrenClassName="flex flex-col gap-6 overflow-hidden max-h-full"
      panelClassName="max-h-[calc(100%-48px)]"
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>
          {data?.title ? (
            data.title
          ) : (
            <Skeleton className="mx-auto h-8 w-[200px] rounded" />
          )}
        </Dialog.Title>
      </Dialog.Header>
      <div className="max-h-full max-w-full overflow-hidden rounded-lg">
        {data?.url ? (
          <video
            autoPlay
            playsInline
            controls
            controlsList="nodownload"
            loop
            className="h-full w-full object-cover"
            src={data.url}
          />
        ) : (
          <Skeleton className="h-[250px] w-full rounded-lg" />
        )}
      </div>
    </Dialog>
  )
}
